export default __webpack_public_path__ + "static/mediopollo-889ee22cad8d5dec9f21497a86d254f4.jpg";